import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const PreOwnedRolex = () => {
  return (
    <Container className="mt-4">
      <Row className="align-items-center">
        <Col md={6}>
          <p>
            <h2 className="mb-3 font-weight-bold">Pre-Owned Rolex</h2>
            Being a symbol of perfection, luxury and beauty for over a century
            in the world of watches, Rolex watches are one of the world's most
            famous watches. From the wide variety of Rolex watches available,
            you will no doubt find one that will taste your taste. <br /> <br />
            Every Rolex watch comes with a 2 year warranty to ensure your
            purchase is safe. Please note that we are not authorized dealers of
            Rolex watches. We only carry Pre-Own Rolex watches. <br /> <br />
            We repair and customize Rolex watches using only the actual Rolex
            components in all movement adjustments and customization. <br />{" "}
            <br />
            Please call ahead, as all showings are by appointment only.   
          </p>
        </Col>
        <Col md={6}>
          <img
            src={require("../../../Front/themes/showcase/assets/images/services/rolex.jpg")}
            alt="certificate"
            className="img-fluid border p-1"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default PreOwnedRolex;
